import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-about-wellbux-vedio-fold',
    templateUrl: './about-wellbux-vedio-fold.component.html',
    styleUrls: ['./about-wellbux-vedio-fold.component.scss'],
    standalone: false
})
export class AboutWellbuxVedioFoldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
